export default __webpack_public_path__ + "static/media/afrax.d502227b.svg";